<div class="notification-modal">
  <div class="text-end">
    <a (click)="closeModal()" class="close text-decoration-none">x</a>
  </div>
  <div class="content-wrapper">
    <img [src]="imageUrl" alt="Icono" class="success-icon" />
    <p>{{ message }}</p>
  </div>
</div>